import { TABLE_CELL_EMPTY_VALUE } from '../../../../common/components/Table/utils/table.const';
import { RestaurantResponse } from '../../../Restaurants/models';
import { LocationCategory } from '../../../Restaurants/models/enums/location-category.enum';
import { AssignedItemResponse } from '../model/assigned-item.response';
import { AssignedItemProductResponse } from '../model/assigned-item-product.response';

type TFunc = (key: string, args?: { [key: string]: string }) => string;

export const getReturnedAtRestaurant = (item: AssignedItemResponse): RestaurantResponse | null => {
  const returnCodeRestaurant = item.returnCode?.restaurant;
  if (returnCodeRestaurant) {
    return returnCodeRestaurant;
  }
  return item.returnRestaurant?.locationCategory !== LocationCategory.PAID ? item.returnRestaurant : null;
};

export const getItemTableCell = (product: AssignedItemProductResponse, t?: TFunc) => {
  const productIdLabel = t ? t('users_eco_fee.common.product_id_label') : 'product ID';
  const itemCellBase = `${product.productName}, ${product.category?.categoryName}`;
  if (product.id) {
    return `${itemCellBase} (${productIdLabel}: ${product.id})`;
  }
  return itemCellBase;
};

export const mapPaymentMethodTypeToLabel = (type: string, t?: TFunc): string => {
  switch (type) {
    case 'credit_card':
      return t ? t('users_eco_fee.payment_methods.credit_card') : 'Credit Card';
    case 'paypal':
      return t ? t('users_eco_fee.payment_methods.paypal') : 'PayPal';
    case 'sepa':
      return t ? t('users_eco_fee.payment_methods.sepa') : 'SEPA';
    case 'ideal':
      return t ? t('users_eco_fee.payment_methods.ideal') : 'iDEAL';
    case 'apple_pay':
      return t ? t('users_eco_fee.payment_methods.apple_pay') : 'Apple Pay';
    case 'google_pay':
      return t ? t('users_eco_fee.payment_methods.google_pay') : 'Google Pay';
    default:
      return t ? t('users_eco_fee.payment_methods.unknown') : 'Unknown';
  }
};

export const mapAssignedItemToEcoFeeReason = (item: AssignedItemResponse, t: TFunc): string => {
  const expiredAt = item.period.due?.timestamp;
  const returnedAt = item.period.end?.timestamp;
  const returnedAtRestaurant = getReturnedAtRestaurant(item);

  if (expiredAt) {
    if (!returnedAt || !returnedAtRestaurant) {
      return t('users_eco_fee.eco_fee.reasons.not_returned');
    }
    if (returnedAt > expiredAt) {
      return t('users_eco_fee.eco_fee.reasons.late_return');
    }
  }

  const pending = item.pendingReturnPeriod;
  if (pending) {
    const restaurantScannedAt = pending.end?.timestamp;
    if (!restaurantScannedAt) {
      return t('users_eco_fee.eco_fee.reasons.two_factor_return.no_restaurant_scan');
    }
    const pendingReturnExpiredAt = pending.due?.timestamp;
    if (pendingReturnExpiredAt && restaurantScannedAt > pendingReturnExpiredAt) {
      return t('users_eco_fee.eco_fee.reasons.two_factor_return.restaurant_late_scan');
    }
  }

  return TABLE_CELL_EMPTY_VALUE;
};
